import { render } from "./reportbarchart.vue?vue&type=template&id=2a98061d&scoped=true"
import script from "./reportbarchart.vue?vue&type=script&lang=js"
export * from "./reportbarchart.vue?vue&type=script&lang=js"

import "./reportbarchart.vue?vue&type=style&index=0&id=2a98061d&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a98061d"]])

export default __exports__